// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__a8iyi","title":"Hero_title__583Jz","text":"Hero_text__1AtqU"};